<template>
  <div class="language-selector" ref="root">
    <button type="button" class="lang-btn" @click="open = !open" :class="{ open }">
      {{ currentLocale.toUpperCase() }}
    </button>
    <div v-if="open" class="lang-dropdown">
      <button
        v-for="l in languages"
        :key="l.code"
        type="button"
        :class="{ active: currentLocale === l.code }"
        @click="select(l.code)"
      >
        {{ l.label }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
const currentLocale = ref(locale.value);
const open = ref(false);
const root = ref(null);

const languages = [
  { code: 'en', label: 'English' },
  { code: 'bg', label: 'Български' },
  { code: 'ar', label: 'العربية' },
  { code: 'he', label: 'עברית' },
  { code: 'el', label: 'Ελληνικά' },
];

const select = (code) => {
  currentLocale.value = code;
  locale.value = code;
  localStorage.setItem('locale', code);
  open.value = false;
};

watch(locale, (newLocale) => {
  currentLocale.value = newLocale;
});

const onDocClick = (e) => {
  if (root.value && !root.value.contains(e.target)) open.value = false;
};
onMounted(() => document.addEventListener('click', onDocClick));
onUnmounted(() => document.removeEventListener('click', onDocClick));
</script>

<style scoped>
.language-selector { position: relative; display: inline-block; }

.lang-btn {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 48px; height: 40px; padding: 0 14px;
  border: 1px solid rgba(31, 41, 51, 0.08); border-radius: 11px;
  background: #ffffff; color: #6b7280;
  font-size: 14px; font-weight: 700; cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
}
.lang-btn:hover, .lang-btn.open { border-color: #2b82f0; color: #2b82f0; }

.lang-dropdown {
  position: absolute; top: calc(100% + 8px); right: 0; z-index: 200;
  min-width: 160px; padding: 6px;
  background: #ffffff; border: 1px solid rgba(31, 41, 51, 0.08);
  border-radius: 14px; box-shadow: 0 24px 60px -34px rgba(31, 41, 51, 0.4);
  display: flex; flex-direction: column;
}
.lang-dropdown button {
  text-align: left; padding: 10px 12px; border: none; background: none;
  border-radius: 9px; font-size: 14px; font-weight: 600; color: var(--ink, #1f2933);
  cursor: pointer; transition: background 0.15s ease, color 0.15s ease;
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
}
.lang-dropdown button:hover { background: rgba(31, 41, 51, 0.05); }
.lang-dropdown button.active { background: rgba(43, 130, 240, 0.1); color: #2b82f0; }
</style>
